module.exports = __webpack_public_path__ + "static/media/alejandroHernandez.b00631e1.jpg";